;(function () {
	const initializedSections = new WeakSet()

	const getSliderParts = (section) => {
		if (!section) return {}

		return {
			viewport: section.querySelector('[data-box-viewport]'),
			track: section.querySelector('.home-whats-in-the-box__accessories'),
			prevButton: section.querySelector('[data-box-nav="prev"]'),
			nextButton: section.querySelector('[data-box-nav="next"]')
		}
	}

	const getStepWidth = (track) => {
		const firstCard = track?.querySelector('.home-whats-in-the-box__accessory-card')
		if (!firstCard) return 0

		const trackStyles = window.getComputedStyle(track)
		const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0')

		return firstCard.getBoundingClientRect().width + gap
	}

	const updateNavState = (section) => {
		const { viewport, prevButton, nextButton } = getSliderParts(section)
		if (!viewport || !prevButton || !nextButton) return

		const maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth)
		const currentScrollLeft = viewport.scrollLeft
		const tolerance = 2
		const isAtStart = currentScrollLeft <= tolerance
		const isAtEnd = currentScrollLeft >= maxScrollLeft - tolerance

		prevButton.disabled = isAtStart
		nextButton.disabled = isAtEnd

		prevButton.classList.toggle('home-whats-in-the-box__nav-button--disabled', isAtStart)
		nextButton.classList.toggle('home-whats-in-the-box__nav-button--disabled', isAtEnd)
	}

	const scrollByCard = (section, direction) => {
		const { viewport, track } = getSliderParts(section)
		if (!viewport || !track) return

		const stepWidth = getStepWidth(track)
		if (!stepWidth) return

		viewport.scrollBy({
			left: stepWidth * direction,
			behavior: 'smooth'
		})

		window.setTimeout(() => updateNavState(section), 350)
	}

	const initWhatsInTheBox = (section) => {
		if (!section || initializedSections.has(section)) return

		const { viewport, prevButton, nextButton } = getSliderParts(section)
		if (!viewport || !prevButton || !nextButton) return

		prevButton.addEventListener('click', () => scrollByCard(section, -1))
		nextButton.addEventListener('click', () => scrollByCard(section, 1))
		viewport.addEventListener('scroll', () => updateNavState(section), { passive: true })

		initializedSections.add(section)
		updateNavState(section)
	}

	const initAllWhatsInTheBox = () => {
		document.querySelectorAll('.home-whats-in-the-box').forEach(initWhatsInTheBox)
	}

	document.addEventListener('DOMContentLoaded', () => {
		initAllWhatsInTheBox()

		window.addEventListener('resize', () => {
			document.querySelectorAll('.home-whats-in-the-box').forEach(updateNavState)
		})

		document.addEventListener('shopify:section:load', (event) => {
			const section = event.target.querySelector('.home-whats-in-the-box')
			if (section) {
				initWhatsInTheBox(section)
			}
		})
	})
})()
